export const getEntityErrorType = (entityName: string) => ({
  CLEAR_VALIDATION: `${entityName}:CLEAR_VALIDATION`,
  CLEAR_ERROR: `${entityName}:CLEAR_ERROR`,
  THROW_ERROR: `${entityName}:THROW_ERROR`,
});
